import { FC } from 'react';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';
import PartnersTableViewHeader from './PartnersTableViewHeader';
import PartnersTableViewBody from './PartersTableViewBody';
import { useNotifyPartnersDividendsModal } from '../context/NotifyPartnersDividendsModalContext';

const PartnersTableView: FC = () => {
  const { data, actions } = useNotifyPartnersDividendsModal();
  return (
    <div className="card card-bordered">
      <PartnersTableViewHeader />

      <PartnersTableViewBody />

      {data.expandView && (
        <DataTablePagination
          itemPerPage={data.rowsPerPage || 10}
          totalItems={data.totalPartners || 0}
          paginate={actions.handleChangePage}
          currentPage={data.currentPage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
          customItemPerPage={0}
          setRowsPerPage={() => {}}
        />
      )}
    </div>
  );
};

export default PartnersTableView;
